import type { DataMode } from '@infra/licence/ActivationClaims';
import type { RepositoriesBundle } from './adapters/RepositoriesBundle';

/** Moteur de stockage effectif côté poste. */
export type PersistenceEngine = 'dexie' | 'sqlite' | 'remote-api';

/** Descripteur exposé à l’UI / diagnostics (paramètres, logs). */
export interface PersistenceDescriptor {
  dataMode: DataMode;
  engine: PersistenceEngine;
  /** Dexie reste la source primaire tant que P7-03 n’est pas livré. */
  dexiePrimary: boolean;
  sqliteAvailable?: boolean;
  sqliteSchemaVersion?: number;
  /** Mode distant : API métier (`nexxus-business-api`) pas encore déployée. */
  remoteApiBlocked?: boolean;
  remoteApiReason?: string;
}

/**
 * Contrat commun de persistance.
 * Les adapters Local/Remote implémentent RepositoriesBundle ; ce port ajoute les métadonnées.
 */
export interface IPersistencePort extends RepositoriesBundle {
  describe(): PersistenceDescriptor;
}

/** Raison documentée pour le mode distant incomplet sans business-api. */
export const BUSINESS_API_DEFERRED_REASON =
  'Projet nexxus-business-api (PostgreSQL) non encore créé — cache local Dexie uniquement.';
